const config = {
    API_URL: process.env.REACT_APP_API_URL,
    API_CLOUD_URL: 'https://text-stock.com/',
};

export default config;
